exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-data-table td[data-v-6f1003de],.v-data-table th[data-v-6f1003de]{padding:0 16px}.v-data-table th[data-v-6f1003de]:first-child{min-width:120px}", ""]);

// exports
